module.exports = __webpack_public_path__ + "static/img/card_4_13.b5c3f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_4_13.png
// module id = mTeF
// module chunks = 0